import $ from 'jquery';
import search from 'modules/search';

function initSearch() {
    search.init();
}

$(document).ready(function() {
    initSearch();
});

function WishlistCountUpdater() {
    /**
     * Update the wishlist items count.
     * @param onUpdate the callback function executed on successful count update. The count value is passed as the first
     *  argument to the callback function.
     */
    this.updateCount = function(onUpdate) {
        $.ajax({
            type: 'POST',
            url: "/fw/ajax/GetWishlistItemsCount.jsp",
            success: function(ajaxResponse) {
                var responseObject = JSON.parse(ajaxResponse);
                if(responseObject.success) {
                    var count = responseObject.data;
                    if(count < 100) {
                        $("#wishlist_item_count").text(count);
                    } else {
                        $("#wishlist_item_count").text("99+");
                    }
                    var limit = responseObject.limit;
                    $("#wishlist_item_count").data('count', count);
                    $("#wishlist_item_count").data('limit', limit);
                    if (responseObject.maxPopup) {
                        $('#wish-max-popup-div').empty().append(responseObject.maxPopup);
                    }
                    if(typeof onUpdate === 'function') {
                        onUpdate(count);
                    }
                }
            }
        });
    };

    this.showWishListMaxRestrictionPopup = function() {
        var productCount = 0;
        var maxLimit = 0;
        var str = $("#wishlist_item_count").data('count');
        if(!Number.isNaN(Number(str))){
            productCount = Number(str);
        }
        str = $("#wishlist_item_count").data('limit');
        if(!Number.isNaN(Number(str))){
            maxLimit = Number(str);
        }
        if (productCount >= maxLimit && $("#restrict-favorites").length) {
            $.modal({triggerOpen:true, open: "restrict-favorites"});
            return true;
        }
        return false;
    }

}

function clearOldWishItems() {
    $.ajax({
        type: 'GET',
        url: '/fw/content/wishlist/clearOldItems',
        success: function () {
            window.location.search += `&${window.rcProps.clearWishlistUrlParam}=true`;
        }
    });
}

$(document).ready(function() {
    window.WishlistCountUpdater = WishlistCountUpdater;
    window.clearOldWishItems = clearOldWishItems;
    //Get initial wishlist count
    var wishlistCountUpdater = new WishlistCountUpdater();
    wishlistCountUpdater.updateCount();
    if($('.js-slideshow').find('.cookie-banner-slide').length == 0) {
        $('.cookie-banner-global').show();
    }
    $(".js-close-banner-custom").click(function (e) {
        e.preventDefault();
        var el = $(".banner--slider-list__item.slick-active");
        if($(".banner--slider-list__item.slick-active").find('.cookie-banner-slide').length) {
            if (typeof cookiesClose === "function") {
                $('.js-slideshow').slick('slickRemove', $('.slick-slide').index(el) - 1);
                cookiesClose();
                el.remove();
            }
        } else {
            if($('.js-slideshow').find('.cookie-banner-slide').length) {
                $('.cookie-banner-global').show();
            }
            const slideClosed = $(this).siblings('.banner--slider-list').find('.banner--slider-list__item');
            $('.js-close-parent').hide().remove();
            $.post("/r/ajax/SetRevolveSessionParam.jsp", $.param({
                "key": "fglobalbannerdismiss",
                "value": "disableglobalbanner"
            }), function () {});
        }
    });

    if (rcProps.cart && rcProps.cart.detailsHref) {
        $.ajax({
            cache: false,
            url: rcProps.cart.detailsHref,
            dataType: 'json',
            success: function (data) {
                $('#shopping_bag_count').html(data.itemCount);
            },
        });
    }
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/header/index.js